import React from "react";

// const TabCard = ({ icon, heading, className, bgColor = "#E3B027", textColor = "white", onClick }) => {
//   return (
//     <div
//     onClick={onClick}
//       className={`h-[120px] min-w-[210px] rounded-md flex flex-col items-center justify-center border cursor-pointer border-primary ${className}`}
//       // style={{ backgroundColor: bgColor, borderColor: bgColor }}
//     >
//       <div className="mb-2">
//         <img src={icon} alt="icon" className="h-8 w-8" />
//       </div>
//       <p className="text-lg font-semibold" style={{ color: textColor }}>
//         {heading}
//       </p>
//     </div>
//   );
// };

const TabCard = ({ icon, hoverIcon, heading, className, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`group h-[120px] min-w-[210px] rounded-md flex flex-col items-center justify-center border cursor-pointer border-primary transition-all duration-300 ease-in-out
      bg-white text-[#E3B027] hover:bg-[#E3B027] hover:text-white ${className}`}
    >
      <div className="mb-2 relative">
        {/* Default Icon */}
        <img src={icon} alt="icon" className="h-8 w-8 group-hover:hidden" />

        {/* Hover Icon (White) */}
        <img src={hoverIcon} alt="icon-hover" className="h-8 w-8 hidden group-hover:block" />
      </div>
      <p className="text-lg font-semibold">{heading}</p>
    </div>
  );
};

export default TabCard;
